import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import s from './ReportProblem.module.css';
import { Modal } from 'components/common/Modal/Modal';
import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';
import { Button } from 'components/common/Button/Button';
import { PortalComponent } from 'components/common/PortalComponent';
import { useReportProblemMutation } from 'store/features/user/user-api';
import { useQueryError } from 'lib/hooks/useQueryError';
import { ErrorModal } from 'components/common/ErrorModal/ErrorModal';
import { Loader } from 'components/common/Loader/Loader';

export const ReportProblem = () => {
  const { t } = useTranslation();

  const { closeRouteModal, goBack } =
    useOutletContext<ModalNavigationContext>();

  const [reportProblem, { isSuccess, isLoading, isError, error: queryError }] =
    useReportProblemMutation();
  const { showError, errorMessage, closeError } = useQueryError(
    isError,
    queryError,
  );

  // const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const [problem, setProblem] = useState<string>('');

  const isDisabled = !problem.trim();

  const handleChangeProblem = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setProblem(e.target.value);
  };

  const handleApply = async () => {
    try {
      await reportProblem(problem).unwrap();
      setProblem('');
    } catch (submitError) {
      console.error(submitError);
    }
  };

  return (
    <Modal
      title={t('profile.reportProblem.title')}
      onClose={closeRouteModal}
      onBack={goBack}
    >
      <div className={s['container']}>
        <fieldset className={s['problem-field']}>
          <legend>{t('profile.reportProblem.problem')}</legend>

          <textarea
            className={s['problem-textarea']}
            value={problem}
            onChange={handleChangeProblem}
            placeholder={t('profile.reportProblem.description')}
          />
        </fieldset>

        <Button
          className={s['apply-btn']}
          onClick={handleApply}
          isAccent={true}
          isRounded={true}
          disabled={isDisabled}
        >
          {t('common.apply')}
        </Button>
      </div>

      {isSuccess && (
        <PortalComponent>
          <Modal
            className={s['success-modal']}
            title={t('profile.reportProblem.success.title')}
          >
            <div className={s['thanks']}>
              <p className={s['thanks__text']}>
                {t('profile.reportProblem.success.message')}
              </p>

              <Button className={s['thanks__btn']} onClick={goBack}>
                {t('common.return')}
              </Button>
            </div>
          </Modal>
        </PortalComponent>
      )}

      {isLoading && <Loader />}
      {showError && <ErrorModal message={errorMessage} onClose={closeError} />}
    </Modal>
  );
};
